import React from 'react';
import { Box, InputBase, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    resultCount?: number;
    width?: number | string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder = 'Search...',
    resultCount,
    width = 220,
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box
                sx={{
                    position: 'relative',
                    width,
                }}
            >
                <SearchIcon
                    sx={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: '14px',
                        height: '14px',
                        color: COLORS.grayMedium,
                    }}
                />
                <InputBase
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    sx={{
                        width: '100%',
                        border: `1px solid ${COLORS.border}`,
                        borderRadius: '6px',
                        padding: '6px 10px 6px 32px',
                        fontSize: '13px',
                        fontFamily: 'Poppins, sans-serif',
                        color: COLORS.textPrimary,
                        backgroundColor: '#fff',
                        '& input::placeholder': {
                            color: '#B0B8C4',
                            opacity: 1,
                        },
                        '&.Mui-focused': {
                            borderColor: COLORS.primary,
                        },
                    }}
                />
            </Box>
            {resultCount !== undefined && value && (
                <Typography sx={{ fontSize: '11px', color: COLORS.grayMedium }}>
                    {resultCount} match{resultCount !== 1 ? 'es' : ''}
                </Typography>
            )}
        </Box>
    );
};
